'use client';
import React from 'react';
import { Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

function Clients() {
  const swiperOptions = {
    modules: [Autoplay],
    slidesPerView: 5,
    loop: true,
    spaceBetween: 40,
    speed: 3000,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },
    breakpoints: {
      0: {
        slidesPerView: 2,
      },
      640: {
        slidesPerView: 3,
      },
      768: {
        slidesPerView: 3,
      },
      1024: {
        slidesPerView: 5,
      },
    },
  };
  return (
    <section className="clients-carso section-padding pt-0">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-6 col-md-10">
            <div className="sec-head text-center mb-80 wow fadeInUp">
              <h3>
                Quem já <span className="main-color">navegou</span> com a gente
              </h3>
            </div>
          </div>
        </div>
        <div
          className="swiper5"
          data-carousel="swiper"
          data-items="5"
          data-loop="true"
          data-space="40"
        >
          <Swiper
            {...swiperOptions}
            id="content-carousel-container-unq-clients"
            className="swiper-container"
            data-swiper="container"
          >
            {Array.from({ length: 17 }, (_, i) => i + 1).map((n) => (
              <SwiperSlide key={n}>
                <div className="item">
                  <div className="img icon-img-100">
                    <img src={`/assets/imgs/brands/${n}.png`} alt="" />
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
        <div className="sec-bottom mt-100">
          <div className="main-bg d-flex align-items-center">
            <h6 className="fz-14 fw-400">
              <span className="fw-600">+200 clientes</span> atendidos
            </h6>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Clients;
